module.exports = __webpack_public_path__ + "assets/img/CGTN-africa.042eef1c.jpg";